export default __webpack_public_path__ + "static/media/BG_Video_Mist.ac65f9c9.mp4";